import services from '../services'
import * as types from './mutation-types'

// Controls
export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_CONTROLS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_CONTROL, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_CONTROL, res.data.data)
    return res
  })
}

export const remove = async ({ commit }, id) => {
  await services.remove(id).then(res => {
    return res
  })
}

// Items
export const getItems = ({ commit }, { controlId, params }) => (
  services.listItems(controlId, params).then(res => {
    commit(types.SET_ITEMS, res.data)
  })
)

export const showItem = async ({ commit }, { controlId, id }) => {
  await services.showItem(controlId, id).then(res => {
    commit(types.SET_ITEM, res.data.data)
  })
}

export const saveItem = async ({ commit }, { controlId, data }) => {
  await services.saveItem(controlId, data).then(res => {
    commit(types.SET_ITEM, res.data.data)
    return res
  })
}

export const removeItem = async ({ commit }, { controlId, id }) => {
  await services.removeItem(controlId, id).then(res => {
    return res
  })
}

// Groups
export const getGroups = ({ commit }, { controlId, params }) => (
  services.listGroups(controlId, params).then(res => {
    commit(types.SET_GROUPS, res.data)
  })
)

export const saveGroup = async ({ commit }, { controlId, data }) => {
  await services.saveGroup(controlId, data).then(res => {
    commit(types.SET_GROUP, res.data.data)
    return res
  })
}

export const removeGroup = async ({ commit }, { controlId, id }) => {
  await services.removeGroup(controlId, id).then(res => {
    return res
  })
}
